<template>
  <div class="min-h-screen">
    <StudyIndex v-if="view === 'studies'" />
    <StudyPage v-else-if="view === 'study'" :study-id="id" />
    <FramePage v-else-if="view === 'frame'" :frame-id="id" />
  </div>
</template>

<script>
import StudyIndex from './StudyIndex.vue';
import StudyPage from './StudyPage.vue';
import FramePage from './FramePage.vue';

export default {
  name: 'ImpactAnalytics',
  components: { StudyIndex, StudyPage, FramePage },
  props: {
    view: { type: String, default: 'studies' },
    id: { type: Number, default: null },
  },
};
</script>
